import Reveal from "@/components/landing/Reveal";

const spots = [
  { img: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=800&q=80", label: "Fintech · Berlin" },
  { img: "https://images.unsplash.com/photo-1556761175-b413da4baf72?auto=format&fit=crop&w=800&q=80", label: "AI Lab · Toronto" },
  { img: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=800&q=80", label: "Design Studio · Copenhagen" },
  { img: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=800&q=80", label: "HealthTech · Singapore" },
  { img: "https://images.unsplash.com/photo-1531482615713-2afd69097998?auto=format&fit=crop&w=800&q=80", label: "Climate Startup · Amsterdam" },
  { img: "https://images.unsplash.com/photo-1517048676732-d65bc937f952?auto=format&fit=crop&w=800&q=80", label: "Gaming Studio · Seoul" },
];

export default function Gallery() {
  const row = [...spots, ...spots];
  return (
    <section data-testid="gallery-section" className="py-24 sm:py-28 overflow-hidden">
      <Reveal className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 mb-12 flex flex-col sm:flex-row sm:items-end justify-between gap-6">
        <div>
          <p data-testid="gallery-eyebrow" className="font-mono text-xs uppercase tracking-[0.25em] text-bronze mb-4">
            The Launch Cohort
          </p>
          <h2 data-testid="gallery-heading" className="font-serif text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight leading-tight max-w-xl">
            A glimpse of <span className="italic text-bronze">who&rsquo;s hiring</span>
          </h2>
        </div>
        <p className="max-w-xs text-sm sm:text-base font-light text-ink-soft leading-relaxed">
          Fifty vetted companies open their doors on day one. Here is a preview of the workplaces waiting.
        </p>
      </Reveal>

      <div className="animate-marquee flex w-max gap-6 pr-6">
        {row.map((s, i) => (
          <figure
            key={i}
            data-testid={i < spots.length ? `gallery-card-${i + 1}` : undefined}
            className="group relative h-60 sm:h-72 w-72 sm:w-80 shrink-0 overflow-hidden rounded-3xl border border-ink/10"
          >
            <img
              src={s.img}
              alt={s.label}
              loading="lazy"
              className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-navy/60 via-transparent to-transparent" />
            <figcaption className="absolute bottom-4 left-4 rounded-full border border-white/30 bg-navy/50 backdrop-blur-md px-4 py-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-sand">
              {s.label}
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}
